<div class="table-selection-dialog">
  <sc-flex [vertical]="true" [stretchContent]="true" [fitHeight]="true">
    <sc-dialog-title>{{data.title}}</sc-dialog-title>
    <div class="top-info"></div>
    <sc-flex-fitting-content [vertical]="true">
      <sc-padding [fitHeight]="true">
        <sc-tmc-table [tableModel]="tableModel" #tmcTableComponent></sc-tmc-table>
      </sc-padding>
    </sc-flex-fitting-content>
    <sc-actionbar>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button class="cancel-button" (click)="cancelDialog()"
        [disabled]="isCancelDisabled()">{{'cancel' |
        translate:['shared.selection-dialog.action.cancel', translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button class="confirm-button" (click)="confirm()">{{'confirm' |
        translate:['shared.selection-dialog.action.confirm', translationService.language]}}</button>
    </sc-actionbar>
  </sc-flex>
</div>
